export const ToColorHex = (index: number): string => {
    switch (index) {
        case 1:
            return "#F15854";
        case 2:
            return "#5DA5DA";
        case 3:
            return "#60BD68";
        case 4:
            return "#FAA43A";
        case 5:
            return "#F17CB0";
        case 6:
            return "#DECF3F";
        case 7:
            return "#B2912F";
        case 8:
            return "#B276B2";
        case 9:
            return "#70bb58";
        case 10:
            return "#e2ec46";
        case 11:
            return "#b18d02";
        case 12:
            return "#13c356";
        case 13:
            return "#1d8b81";
        case 14:
            return "#39555e";
        case 15:
            return "#9124e5";
        case 16:
            return "#4332cb";
        case 17:
            return "#33a80a";
        case 18:
            return "#712277";
        case 19:
            return "#5e6d00";
        case 20:
            return "#4f7726";
        default:
            return "#000000";
    }
};
